<template>
  <div>
    <v-app-bar flat color="transparent" class="main-appbar">
      <app-bar-nav-icon />
      <v-skeleton-loader
        type="chip"
        transition="fade-transition"
        v-if="loading"
      ></v-skeleton-loader>

      <v-toolbar-title v-else class="headline font-weight-bold"
        >Plans ({{ listMeta.total }})</v-toolbar-title
      >

      <v-spacer></v-spacer>

      <v-btn color="primary" class="mb-2" @click="addPlanDialog = true">
        <v-icon left> {{ icons.add }} </v-icon>Add Plan
      </v-btn>
    </v-app-bar>

    <div class="mt-12 mb-6">
      <v-row>
        <v-col cols="6" md="3">
          <v-text-field
            outlined
            clearable
            hide-details
            label="Search"
            @input="doFilter"
            placeholder="Search by Name"
            v-model="search"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>

    <v-data-table
      :items="plans"
      :loading="loading"
      :headers="headers"
      class="elevation-1"
      :options.sync="options"
      :server-items-length="listMeta.total"
      :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
    >
      <template v-slot:top="{ pagination, options, updateOptions }">
        <v-data-footer
          :pagination="pagination"
          :options="options"
          @update:options="updateOptions"
          items-per-page-text="$vuetify.dataTable.itemsPerPageText"
          :items-per-page-options="[10, 20, 50, 100]"
        />
      </template>
      <template v-slot:[`item.category`]="{ item }">
        <span class="text-capitalize">{{ item.category }}</span>
      </template>
      <template v-slot:[`item.created_at`]="{ item }">
        {{ item.addedDate }}
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          small
          block
          depressed
          @click="
            $router.push({
              name: 'plans.details',
              params: { id: item.id }
            })
          "
        >
          Edit
        </v-btn>
      </template>
    </v-data-table>

    <AddPlanDialog v-model="addPlanDialog" />
  </div>
</template>

<script>
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import ControlsMixin from '@/utils/mixins/Controls'
import { mdiPlus } from '@mdi/js'
import { mapState, mapActions, mapMutations } from 'vuex'
import debounce from 'lodash/debounce'
import AddPlanDialog from './components/AddPlanDialog.vue'

export default {
  name: 'PlansPage',
  mixins: [ControlsMixin],
  components: {
    AppBarNavIcon,
    AddPlanDialog
  },
  data() {
    return {
      addPlanDialog: false,
      icons: {
        add: mdiPlus
      },
      loading: false,
      options: {},
      headers: [
        {
          text: 'Name',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Number of Weeks',
          sortable: false,
          value: 'weeks_count',
          width: '200px',
          align: 'center'
        },
        {
          text: 'Category',
          sortable: false,
          value: 'category',
          width: '200px'
        },
        {
          text: 'Date Created',
          sortable: true,
          value: 'created_at',
          width: '200px'
        },
        {
          text: 'Actions',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: '150px'
        }
      ],
      search: null
    }
  },
  computed: {
    ...mapState({
      plans: state => state.plan.list,
      listMeta: state => state.plan.listMeta
    })
  },
  methods: {
    ...mapActions({
      getPlans: 'plan/getPlans'
    }),

    ...mapMutations({
      clearPlans: 'plan/clearPlanList'
    }),

    async getDataFromApi() {
      this.loading = true
      this.clearPlans()
      await this.getPlans({
        search: this.search,
        ...this.options
      })
      this.loading = false
    },

    doFilter: debounce(function() {
      this.getDataFromApi()
    }, 600)
  },
  watch: {
    options: {
      handler() {
        this.getDataFromApi()
      },
      deep: true
    }
  }
}
</script>
